export class TipoDocumentoDTO {
	codice: string;
	descrizione: string;
	id: string;
}